import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { UiServices } from 'src/app/services/ui-services';

@Component({
  selector: 'app-decline-reason',
  templateUrl: './decline-reason.component.html',
  styleUrls: ['./decline-reason.component.scss'],
})
export class DeclineReasonComponent implements OnInit {
  constructor(
    private modalController: ModalController,
    private _uiSv: UiServices
  ) {}

  ngOnInit() {}

  dismissModal(value) {
    this.modalController.dismiss(value);
  }

  async sureClose() {
    const { role } = await this._uiSv.presentAlert(
      '¿Deseas cerrar sin dejar una razón de rechazo?',
      true
    );
    if (role === 'accept') {
      this.dismissModal('');
    }
  }
}
